import { AUTH0_ROLES } from '@omnipresentgroup/constants';
import { UserRoleType } from '@omnipresentgroup/types';

import type { AuthenticatedUser } from '../types';

export const isEmployeeUser = (user: AuthenticatedUser) => {
  return Object.values(user?.[AUTH0_ROLES])
    .map((role) => role.type)
    .includes(UserRoleType.EMPLOYEE);
};

export const isAdminUser = (user: AuthenticatedUser) => {
  return Object.values(user?.[AUTH0_ROLES])
    .map((role) => role.type)
    .includes(UserRoleType.ADMIN);
};

export const isCSAdminUser = (user: AuthenticatedUser) => {
  return Object.values(user?.[AUTH0_ROLES])
    .map((role) => role.type)
    .includes(UserRoleType.CS);
};

export const isManagerUser = (user: AuthenticatedUser) => {
  return Object.values(user?.[AUTH0_ROLES])
    .map((role) => role.type)
    .includes(UserRoleType.MANAGER);
};

export const isContractorUser = (user: AuthenticatedUser) => {
  return Object.values(user?.[AUTH0_ROLES])
    .map((role) => role.type)
    .includes(UserRoleType.CONTRACTOR);
};

export const isIEAdminUser = (user: AuthenticatedUser) => {
  return Object.values(user?.[AUTH0_ROLES])
    .map((role) => role.type)
    .includes(UserRoleType.INTERNATIONAL_EXPANSION);
};

export const isOmniHRUser = (user: AuthenticatedUser) => {
  return Object.values(user?.[AUTH0_ROLES])
    .map((role) => role.type)
    .includes(UserRoleType.OMNI_HR);
};

export const isFinanceUser = (user: AuthenticatedUser) => {
  return Object.values(user?.[AUTH0_ROLES])
    .map((role) => role.type)
    .includes(UserRoleType.FINANCE);
};

export const isPayrollUser = (user: AuthenticatedUser) => {
  return Object.values(user?.[AUTH0_ROLES])
    .map((role) => role.type)
    .includes(UserRoleType.PAYROLL);
};

export const isLSPUser = (user: AuthenticatedUser) => {
  return Object.values(user?.[AUTH0_ROLES])
    .map((role) => role.type)
    .includes(UserRoleType.LSP);
};
